import { Typography } from '@mui/material';

/** The informational explanation of what the Contract Favorability Index is.
 * Shared between the consultant idle/run state and the client read-only view so
 * the copy stays in one place. */
export const CfiIntro = () => (
  <>
    <Typography variant="h6" gutterBottom>
      ContractIQ
    </Typography>
    <Typography variant="body2" color="text.secondary" paragraph>
      ContractIQ is an AI-assisted review that evaluates this elevator service contract from the
      property owner&rsquo;s perspective. It reads the attached PDF, locates each clause, and rates
      it as favorable, neutral, or unfavorable against Lift AI&rsquo;s consultant rubric.
    </Typography>
    <Typography variant="body2" color="text.secondary" paragraph>
      Each report scores 18 core provisions (term, termination, price escalation, scope, liability,
      etc.) and flags additional noteworthy clauses it discovers. Every finding cites the contract
      text it relied on, so a consultant can verify and edit the report before it&rsquo;s approved.
    </Typography>
  </>
);
